export default __webpack_public_path__ + "static/woman-developer-thinking--mobile-2a8ec210be4414760a01fe36c060c8c3.jpg";